export const generateAddress = ({
  addressLines,
  postalCode,
}: {
  addressLines?: string[];
  postalCode?: string;
}) => {
  if (!addressLines?.length) {
    return;
  }
  if (postalCode) {
    const address = [...addressLines, postalCode];
    return address.join(', ');
  }
  return addressLines.join(', ');
};
